"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserCheck = void 0;
const tslib_1 = require("tslib");
const detect_browser_1 = require("detect-browser");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const modal_service_1 = require("../components/modal/modal.service");
const i18n_1 = require("../i18n");
const mithril_1 = require("../mithril");
const compatibleBrowsers = ['edge', 'edge-ios', 'edge-chromium', 'chrome', 'chromium-webview', 'firefox'];
const incompatibleOS = ['iOS', 'Android OS', 'BlackBerry OS', 'Windows Mobile'];
const USE_INCOMPATIBLE_BROWSER_OS = 'useIncompatibleBrowserOS';
const EXPIRY_COOKIE_DAYS = 1;
class BrowserCheck {
    constructor() {
        this.browser = (0, detect_browser_1.browserName)(navigator.userAgent);
        this.os = (0, detect_browser_1.detectOS)(navigator.userAgent);
    }
    validateBrowser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const dismissedMessageCookie = js_cookie_1.default.get(USE_INCOMPATIBLE_BROWSER_OS);
            if (dismissedMessageCookie) {
                return;
            }
            let result = { ok: false, cancel: false };
            if (incompatibleOS.includes(this.os)) {
                result = yield modal_service_1.ModalService.open({
                    title: i18n_1.T.MESSAGE_MOBILE_VALIDATION_TITLE,
                    content: (0, i18n_1.Translate)(i18n_1.T.MESSAGE_MOBILE_VALIDATION_CONTENT),
                    hasCancel: false,
                    canClose: () => true
                });
            }
            else if (!compatibleBrowsers.includes(this.browser)) {
                result = yield modal_service_1.ModalService.open({
                    title: i18n_1.T.MESSAGE_BROWSER_VALIDATION_TITLE,
                    content: () => (0, mithril_1.m)('div', [
                        (0, mithril_1.m)('span', (0, i18n_1.Translate)(i18n_1.T.MESSAGE_BROWSER_VALIDATION_CONTENT)),
                        (0, mithril_1.m)('a', { href: (0, i18n_1.Translate)(i18n_1.T.MESSAGE_BROWSER_VALIDATION_URL), target: '_blank' }, (0, i18n_1.Translate)(i18n_1.T.MESSAGE_BROWSER_VALIDATION_URL_TEXT))
                    ]),
                    hasCancel: false,
                    canClose: () => true
                });
            }
            if (result.ok) {
                js_cookie_1.default.set(USE_INCOMPATIBLE_BROWSER_OS, '1', { expires: EXPIRY_COOKIE_DAYS });
            }
        });
    }
}
exports.BrowserCheck = BrowserCheck;
//# sourceMappingURL=browser-check.js.map